(() => {
  function initialize(root = document) {
    root.querySelectorAll("[data-product-section]").forEach((section) => {
      if (section.dataset.ready) return;
      const select = section.querySelector("[data-variant-select]");
      if (!select) return;
      const variants = JSON.parse(
        section.querySelector("[data-variants]").textContent,
      );
      section.dataset.ready = "true";
      section.classList.add("js-product");
      const quantityInput = section.querySelector("[data-quantity]");
      const minus = section.querySelector("[data-quantity-minus]");
      const plus = section.querySelector("[data-quantity-plus]");
      const guide = section.querySelector(".size-guide-dialog");
      function syncQuantityControls() {
        if (!quantityInput || !minus || !plus) return;
        const amount = Number(quantityInput.value);
        const minimum = Number(quantityInput.min || 1);
        const maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
        const increment = Number(quantityInput.step || 1);
        minus.disabled = !Number.isFinite(amount) || amount - increment < minimum;
        plus.disabled = !Number.isFinite(amount) || amount + increment > maximum;
      }
      const gallery = section.querySelector("[data-mobile-gallery]");
      const thumbnails = Array.from(section.querySelectorAll("[data-gallery-target]"));
      const galleryItems = gallery ? Array.from(gallery.querySelectorAll("[data-gallery-item]")) : [];
      const mobileMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      function syncColorGallery(options) {
        if (!section.hasAttribute("data-color-gallery")) return;
        const color = options[Number(section.dataset.galleryColorIndex)];
        const changed = color !== section.dataset.galleryColor;
        section.dataset.galleryColor = color;
        galleryItems.forEach(item => { item.hidden = item.dataset.mediaColor !== color; });
        thumbnails.forEach(thumb => { thumb.hidden = thumb.dataset.mediaColor !== color; });
        const first = thumbnails.find(thumb => !thumb.hidden && thumb.hasAttribute("data-gallery-primary")) || thumbnails.find(thumb => !thumb.hidden);
        if (changed || !thumbnails.some(thumb => !thumb.hidden && thumb.getAttribute("aria-pressed") === "true")) {
          thumbnails.forEach(thumb => thumb.setAttribute("aria-pressed", String(thumb === first)));
        }
        if (changed) {
          gallery?.scrollTo({left:0, behavior:"instant"});
          const strip = section.querySelector(".product-thumbnails");
          if (strip) strip.scrollLeft = 0;
        }
      }
      syncColorGallery(Array.from(section.querySelectorAll("[data-option]:checked")).map(input => input.value));

      function updateThumbnail() {
        if (!gallery || !window.matchMedia("(max-width: 799px)").matches) return;
        const edge = gallery.getBoundingClientRect().left;
        const visibleItems = galleryItems.filter(item => !item.hidden);
        let active = visibleItems[0];
        for (const item of visibleItems) {
          if (Math.abs(item.getBoundingClientRect().left - edge) < Math.abs(active.getBoundingClientRect().left - edge)) active = item;
        }
        thumbnails.forEach((thumb) => thumb.setAttribute("aria-pressed", String(thumb.dataset.galleryTarget === active?.id)));
      }
      thumbnails.forEach((thumb) => thumb.addEventListener("click", () => {
        const item = galleryItems.find((entry) => entry.id === thumb.dataset.galleryTarget);
        if (!item || item.hidden || !gallery) return;
        gallery.scrollTo({left: gallery.scrollLeft + item.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: mobileMotion.matches ? "auto" : "smooth"});
      }));
      if (gallery && thumbnails.length) {
        let galleryFrame;
        gallery.addEventListener("scroll", () => {
          cancelAnimationFrame(galleryFrame);
          galleryFrame = requestAnimationFrame(updateThumbnail);
        }, {passive:true});
        updateThumbnail();
      }
      syncQuantityControls();
      section.addEventListener("click", (event) => {
        if (event.target.closest("[data-size-guide-open]") && guide) guide.showModal();
        if (event.target.closest("[data-size-guide-close]") && guide) guide.close();
        if (event.target.closest("[data-quantity-minus]") && quantityInput) {
          quantityInput.stepDown();
          quantityInput.dispatchEvent(new Event("change", {bubbles: true}));
        }
        if (event.target.closest("[data-quantity-plus]") && quantityInput) {
          quantityInput.stepUp();
          quantityInput.dispatchEvent(new Event("change", {bubbles: true}));
        }
      });
      if (quantityInput) {
        quantityInput.addEventListener("input", syncQuantityControls);
        quantityInput.addEventListener("change", syncQuantityControls);
        quantityInput.addEventListener("blur", () => {
          if (!quantityInput.value || !quantityInput.checkValidity()) quantityInput.value = quantityInput.min || "1";
          syncQuantityControls();
        });
      }

      section.addEventListener("change", (event) => {
        if (!event.target.matches("[data-option]")) return;
        const options = Array.from(
          section.querySelectorAll("[data-option]:checked"),
        ).map((input) => input.value);
        const variant = variants.find((v) =>
          v.options.every((option, i) => option === options[i]),
        );
        syncColorGallery(options);
        const button = section.querySelector("[data-add]");
        button.disabled = !variant || !variant.available;
        const cartLabel = button.querySelector("[data-cart-label]");
        if (cartLabel) {
          cartLabel.textContent = !variant ? "Unavailable combination" : variant.available ? "ADD TO CART" : "Sold out";
          const cartPrice = button.querySelector("[data-cart-price]");
          const cartCompare = button.querySelector("[data-cart-compare]");
          cartPrice.hidden = !variant || !variant.available;
          cartCompare.hidden = !variant || !variant.available || !variant.on_sale;
          if (variant) {
            cartPrice.textContent = variant.price;
            cartCompare.textContent = variant.compare;
          }
        } else {
          button.textContent = !variant
          ? "Unavailable combination"
          : variant.available
            ? "Add to bag"
            : "Sold out";
        }
        section.querySelector("[data-availability]").textContent = !variant
          ? "This combination is unavailable."
          : variant.available
            ? "Available"
            : "Sold out";
        const saving = section.querySelector("[data-saving]");
        if (saving) {
          saving.hidden = !variant || !variant.on_sale;
          if (variant && variant.on_sale && variant.compare_raw > 0) saving.textContent = saving.dataset.savingLabel + " " + Math.round((variant.compare_raw - variant.price_raw) * 100 / variant.compare_raw) + "%";
        }
        const price = section.querySelector("[data-price]");
        if (price) {
          price.replaceChildren();
          if (variant) {
            price.append(document.createTextNode(variant.price));
            if (variant.on_sale) {
              const s = document.createElement("s");
              s.textContent = variant.compare;
              price.append(" ", s);
            }
          }
        }
        if (!variant) {
          select.disabled = true;
          return;
        }
        select.disabled = false;
        select.value = String(variant.id);
        const quantity = section.querySelector("[data-quantity]");
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max != null) quantity.max = variant.max;
        else quantity.removeAttribute("max");
        quantity.value = variant.min;
        syncQuantityControls();
        const url = new URL(location.href);
        url.searchParams.delete("cv_color");
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url);
        if (variant.media) {
          const media = section.querySelector('[id$="-' + variant.media + '"]');
          if (media && !media.hidden)
            media.scrollIntoView({ behavior: "auto", block: "nearest" });
        }
      });
      // Keep old preview links working by selecting a real, purchasable variant.
      const legacyColor = new URL(location.href).searchParams.get("cv_color");
      if (legacyColor && section.hasAttribute("data-color-gallery")) {
        const colorInput = Array.from(section.querySelectorAll("[data-option]")).find(input =>
          input.dataset.option === section.dataset.galleryColorIndex && input.value.toLowerCase().replaceAll(" ", "-") === legacyColor.toLowerCase());
        if (colorInput) {
          colorInput.checked = true;
          colorInput.dispatchEvent(new Event("change", {bubbles:true}));
        }
      }
    });
  }
  class Recommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = "true";
      fetch(this.dataset.url)
        .then((r) => {
          if (!r.ok) throw new Error("Recommendations unavailable");
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const content = doc.querySelector("product-recommendations");
          if (content) this.innerHTML = content.innerHTML;
        })
        .catch(() => {});
    }
  }
  customElements.define("product-recommendations", Recommendations);
  initialize();
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
})();

